// for assign
/**
 * 铁路票  to print [1] && 不包含逆向流
 * 实体卡  wait for mail [3] && wait for redeem [5] && 不包含逆向流
 */
import { MessageBox, Message } from "element-ui";
import { assignOrder } from "@/services/fulfillment-api";
export default {
  methods: {
    checkAssignTo(booking) {
      let info = booking.order_base_info;
      // 铁路票
      if (info.template_id === 1) {
        return [1].includes(info.status) && !booking.hasReverse;
      } else {
        return [3, 5].includes(info.status) && !booking.hasReverse;
      }
    },
    // 转让订单
    async confirmAssignTo(ids) {
      MessageBox({
        title: "Assign To",
        showCancelButton: true,
        confirmButtonText: this.$t("global_confirm"),
        cancelButtonText: this.$t("global_cancel"),
        closeOnClickModal: false,
        message: (
          <el-select
            value={this.region_id}
            onInput={val => {
              this.region_id = val;
              this.$refs.select.value = val;
            }}
            ref="select"
            clearable
          >
            {this._l(this.config.assign_ops, option => (
              <el-option
                key={option.value}
                label={option.label}
                value={option.value}
              />
            ))}
          </el-select>
        ),
        beforeClose: async (action, instance, done) => {
          // 取消
          if (action === "cancel") {
            this.region_id = "";
            return done();
          }
          // 未选择地区
          if (this.region_id === "") {
            Message(this.$t("ffm_pls_select_an_area"));
            return;
          }
          try {
            await assignOrder({
              order_base_id_list: ids,
              region_id: Number(this.region_id)
            });
            this.search();
            Message(this.$t("ffm_operation_successful"));
          } catch (err) {
            Message(this.$t("ffm_operation_failed"));
          }
          this.region_id = "";
          return done();
        }
      });
    },
    // 单个
    async singleAssignTo(order) {
      // 单独打印
      if ([3, 5].includes(order.order_base_info.status)) {
        let message = "Please confirm to have returned this/these voucher(s).";
        await MessageBox.confirm(message, "Alert", { type: "info" });
      }
      this.confirmAssignTo([order.order_base_info_id]);
    },
    // 批量
    async batchAssignTo() {
      let status = Number(this.status);
      // 判断状态 => to print [1] 时只能选 铁路票
      if (status === 1) {
        let physicals =
          this.selectedItems.filter(v => v.order_base_info.template_id === 2) ||
          [];
        if (physicals.length) {
          Message(
            "The physical products is included in the selected orders, please re-select"
          );
          return;
        }
      }
      // wait for mail [3] && wait for redeem [5] 时只能是实体卡
      if (status === 3 || status === 5) {
        let rails =
          this.selectedItems.filter(v => v.order_base_info.template_id === 1) ||
          [];
        if (rails.length) {
          Message(
            "The rail tickets is included in the selected orders, please re-select"
          );
          return;
        }
      }
      // 是否包含异常订单
      let arr = this.selectedItems.filter(v => !v.hasReverse) || [];
      let ids = arr.map(v => v.order_base_info_id);
      if (!ids.length) {
        Message(this.$t("ffm_all_selected_are_abnormal"));
        return;
      }
      // if
      // 状态为2,3,5, 即已经打印或者是实体卡未寄出之前, 需要提示是否已经确认回收凭证
      if ([3, 5].includes(Number(this.status))) {
        let message = "Please confirm to have returned this/these voucher(s).";
        await MessageBox.confirm(message, "Alert", { type: "info" });
      }
      this.confirmAssignTo(ids);
    },
    // 处理转单, 单个 || 批量
    handleAssignTo(isBatch, order) {
      isBatch ? this.batchAssignTo() : this.singleAssignTo(order);
    }
  }
};
